import { fromEpochMilli, type Instant } from '../time/instant.ts'
import { toLocalDateUtc } from '../time/instant.ts'
import type { LocalDate } from '../time/local-date.ts'

/** `now` is an argument everywhere else in the codebase; this is the only source of it. */
export interface Clock {
  now(): Instant
}

export const systemClock: Clock = {
  now: () => fromEpochMilli(Date.now()),
}

export function fixedClock(instant: Instant): Clock {
  return { now: () => instant }
}

/** Today as the server buckets it: the UTC calendar day. */
export function todayUtc(clock: Clock): LocalDate {
  return toLocalDateUtc(clock.now())
}
